// src/components/ScrollIndicator/ScrollIndicator.jsx
// ou src/pages/Home/ScrollIndicator.jsx selon ton arborescence

import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

const ScrollIndicator = () => {
  const [scrollState, setScrollState] = useState({
    y: 0,
    progress: 0,
    visible: false,
  });

  useEffect(() => {
    let ticking = false;

    const updateScroll = () => {
      const scrollTop =
        window.scrollY || document.documentElement.scrollTop || 0;

      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const progress =
        docHeight > 0 ? Math.min(100, Math.max(0, (scrollTop / docHeight) * 100)) : 0;

      setScrollState({
        y: scrollTop,
        progress,
        visible: scrollTop > 280,
      });

      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScroll);
        ticking = true;
      }
    };

    updateScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", updateScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updateScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const radius = 22;
  const circumference = 2 * Math.PI * radius;
  const dashOffset =
    circumference - (scrollState.progress / 100) * circumference;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Remonter en haut de la page"
      title="Remonter en haut"
      className={`fixed bottom-5 right-5 z-[80] flex h-14 w-14 items-center justify-center rounded-full border border-slate-200 bg-white/90 text-slate-900 shadow-2xl backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:border-primary/40 hover:text-primary dark:border-white/10 dark:bg-slate-950/85 dark:text-white dark:hover:text-primary sm:bottom-6 sm:right-6 ${
        scrollState.visible
          ? "translate-y-0 opacity-100"
          : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <svg
        className="absolute inset-0 h-full w-full -rotate-90"
        viewBox="0 0 56 56"
        aria-hidden="true"
      >
        <circle
          cx="28"
          cy="28"
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          className="text-slate-200 dark:text-white/10"
        />

        <circle
          cx="28"
          cy="28"
          r={radius}
          fill="none"
          stroke="var(--primary-color)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          className="transition-[stroke-dashoffset] duration-150"
        />
      </svg>

      <span className="relative flex h-10 w-10 items-center justify-center rounded-full bg-slate-950 text-white shadow-lg transition group-hover:bg-primary dark:bg-white dark:text-slate-950">
        <FaArrowUp className="text-sm" />
      </span>
    </button>
  );
};

export default ScrollIndicator;